import axios from "axios";
//const API_URL = process.env.VUE_APP_BACKEND_URL;
//const API_URL = 'http://localhost:3001';

// axios.defaults.headers.common.Accept='application/json';
// axios.defaults.headers.common['Content-type'] = 'application/json';
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const getApiUrl = () => {
  // Check if we're in an iframe from autocentrumcr.cz
  if (window.location.hostname === 'www.autocentrumcr.cz') {
    return 'https://floss.pneuprezuti.cz';
  }
  
  // Check current protocol
  if (window.location.hostname.includes('pfloss.dev')) {
    return window.location.origin;
  } else if( window.location.protocol === 'https:') {
    return 'https://floss.pneuprezuti.cz';
  }
  
  // Default to HTTP for development
  return process.env.VUE_APP_BACKEND_URL;
};

//const API_URL = process.env.VUE_APP_BACKEND_URL;
const API_URL = getApiUrl();
console.log('API URL:', API_URL, 'Protocol:', window.location.protocol);
console.log('Location:', window.location);

const myAxios = axios.create({
  baseURL: API_URL,
  //headers: {
  //  "Content-type": "application/json"
  //}
});

myAxios.interceptors.request.use(
    config => {
    // Do something before request is sent
    let user; try{ user = JSON.parse(window.localStorage.getItem('user')); }catch(err){user=null;}
    const token = user?.accessToken || 'TOKEN_NOT_FOUND';
    config.headers['x-access-token'] = token;
    if (config.responseType !== 'blob'){
      config.headers['Accept'] = 'application/json';
      config.headers['Content-type'] = 'application/json';
    } else {
      config.headers['Accept']?.delete;
      config.headers['Content-type']?.delete;
    }
    //console.debug('myAxios.interceptors.request', config.headers);
    return config;
  },
  error => Promise.reject(error)
)

myAxios.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status===403||error?.response?.status===401) {
        //localStorage.removeItem('user');
        let user; try{ user = JSON.parse(window.localStorage.getItem('user')); }catch(err){user=null;}
        if(user?.accessToken) {
            delete(user.accessToken);
            window.localStorage.setItem('user', user);
            return Promise.reject(error?.response?.data?.message);
        } else if (error.request) {
          //console.error(error.request);
          let msg; try{ msg = JSON.parse(error.request?.response); }catch(err){msg=null;}
          const emsg=msg?.message || error.request?.response;
          return Promise.reject(new Error(emsg));
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('Fatal Error', error.message);
          return Promise.reject(new Error(`Request Error: ${error.message}`));
        }
        //window.location.reload(true);
      }
      return Promise.reject(error);
    }
);

export default myAxios;